import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Index = () =>
    import ('@/pages/index/views/home.vue')
const Report = () =>
    import ('@/pages/index/views/report/report.vue')
const weekReport = () =>
    import ('@/pages/index/views/report/weekReport.vue')
const yearReport = () =>
    import ('@/pages/index/views/report/yearReport.vue')
const allReport = () =>
    import ('@/pages/index/views/report/allReport.vue')
const allReports = () =>
    import ('@/pages/index/views/report/allReports.vue')
const specialReport = () =>
    import ('@/pages/index/views/specialReport.vue')
const introduce = () =>
    import ('@/pages/index/views/introduce.vue')
const customReport = () =>
    import ('@/pages/index/views/customReport.vue')
const window = () =>
    import ('@/pages/index/views/window.vue')
const windows = () =>
    import ('@/pages/index/views/windows.vue')

const routes = [{
    path: '/',
    component: Index,
    name: 'home'
}, {
    path: '/report',
    component: Report,
    children: [{
        path: '/weekReport',
        component: weekReport,
        name: 'weekReport',
    }, {
        path: '/yearReport',
        component: yearReport,
        name: 'yearReport',
    }, {
        path: '/allReport',
        component: allReport,
        name: 'allReport',
    }, {
        path: '/allReports',
        component: allReports,
        name: 'allReports',
    }]
}, {
    path: '/specialReport',
    component: specialReport,
    name: 'specialReport',
}, {
    path: '/customReport',
    component: customReport,
    name: 'customReport',
}, {
    path: '/introduce',
    component: introduce,
    name: 'introduce',
}, {
    path: '/window',
    component: window,
    name: 'window',
}, {
    path: '/windows',
    component: windows,
    name: 'windows',
}]
const router = new VueRouter({
    routes
})


router.beforeEach((to, from, next) => {
        // 埋点系统 start
        try {
            if (LogCollection) {
                LogCollection.end()
            }
        } catch (e) {
            console.log(e);
        }
        next()
    })
    // router.afterEach(() => {
    //     try {
    //         if (LogCollection) {
    //             LogCollection.init()
    //         }
    //     } catch (e) {
    //         console.log(e)
    //     }
    // })

// router.beforeEach((to, from, next) => {
//     // console.log('1. 路由导航经过这里，校验是否有 token')
//     $.ajax({ 
//       url: 'http://pay.drcnet.com.cn/eDRCnet.common.web/login.ashx?flag=initp',
//       type: 'get',
//       dataType: 'jsonp',
//       jsonpCallback: 'showData',
//       xhrFields: {
//         withCredentials: true
//       },
//       crossDomain: true,
//       async: false,
//       success: function (data) {
//         // console.log(data, 'long')
//         // console.log(to, 'to')
//         // console.log(window.location, 'window.location.href')
//         if (data.Logined === 1) {
//             setName(data.UserName)
//             setToken(data.UserToken)
//             next()
//         }
//       }
//     })
//   })
export default router